// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--Mc5aa","rating":"_7a3fb80146--rating--v2Lek","details":"_7a3fb80146--details--z2NmG","invisible":"_7a3fb80146--invisible--WyKOr"};